import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';
import moment from 'moment'

import { ReportModal } from '../../components/ReportModal'
import { RunReportModal } from '../../components/RunReportModal'
import {SettingsNav} from '../../components/SettingsNav'

export class SettingsReporting extends React.Component {

  state = {
    reports: [],
    modalOpen: false,
    modalOpen2: false,
    report: null
  }

  componentWillMount() {
    this.fetchReports();
  }

  fetchReports = async () => {
    axios.get('/reports')
        .then(data => {
          this.setState({
            reports: data
          });
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch reports')
        })
  }

  saveChanges = async (data) => {
    let requestParams = {
      'report': data.selectedReport,
      'schedule': {
        'days': data.scheduleDays,
        'time': data.scheduleTime.substring(0, 2) + ':00'
      },
      'parameters': data.parameters,
      'emails': data.emails
    }
    var url = '/reports'
    if (data.report) {
      requestParams = {
        'reportID': data.report.reportID,
        'schedule': {
          'days': data.scheduleDays,
          'time': data.scheduleTime.substring(0, 2) + ':00'
        },
        'emails': data.emails,
        'parameters': data.parameters
      }
      url = '/reports/update'
    }
    axios.post(url, requestParams)
          .then(data => {
            this.fetchReports()
          })
          .catch (err => {
            console.error(err); 
            Rollbar.error(err)
            toast.error("Error: Could not add/edit scheduled report!");
          })
  }

  deleteReport = async (reportID) => {
    axios.delete('/reports/' + reportID)
        .then(data => {
          this.fetchReports();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to delete report')
        })
  }

  editReport = async (report) => {
    this.setState({ modalOpen: true, report: report });
  }

  runReport(report) {
    this.setState({ modalOpen2: true, report: report });
  }

  openModal = () => {
		this.setState({ modalOpen: true });
  };

	closeModal = () => {
		this.setState({ modalOpen: false, modalOpen2: false, report: null });
	};

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Settings</h1>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <SettingsNav/>
                </div>
                <div className="col-md-10 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      Scheduled Reports
                    </div>
                    <div className="card-body">
                      {this.state.reports.map((data, index) =>
                        <div className="card bg-light mb-3" key={index}>
                          <div className="card-body p-3">
                            <div className="row">
                              <div className="col-6 my-auto">
                                <h6 className="m-0">{data.reportName}</h6>
                                <p className="small m-0"><span className="text-primary">
                                  {JSON.parse(data.schedule).days.join(', ')}</span> at 
                                  <span className="text-primary"> {moment(JSON.parse(data.schedule).time, 'HH:mm').format('hh:mm A')}</span>
                                </p>
                              </div>
                              <div className="col-6 text-right my-auto">
                                <button type="button" onClick={() => this.editReport(data)} className="btn btn-info btn-sm">Edit</button>
                                <button type="button" onClick={() => this.runReport(data)} className="btn btn-warning btn-sm ml-2">Run</button>
                                <button type="button" onClick={() => this.deleteReport(data.reportID)} className="btn btn-danger btn-sm ml-2">Delete</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="text-center">
                        <button type="button" className="btn btn-success btn-sm pl-3 pr-3" onClick={this.openModal}>Add Scheduled Report</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
                <ReportModal closeModal={this.closeModal} saveChanges={this.saveChanges} report={this.state.report} />
              </Modal>
              <Modal open={this.state.modalOpen2} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
                <RunReportModal closeModal={this.closeModal} report={this.state.report} />
              </Modal>
            </div>
        );
    }
}
